import React from 'react'
import styled from 'styled-components'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'

import { selectCurrentProject } from 'containers/Dashboard/selectors'

import Modal, {
  ModalContent,
  ModalHeader,
  ModalFooter,
} from '../../../components/modal/Modal'
import { LoadingResponsive } from '../../../components/loading/Loading'
import { OutlineButton, CloseButton } from '../../../components/buttons/Buttons'
import { Text } from '../../../components/topography'
import { palette, fonts } from '../../../styles/variables'
import { translate } from '../../../utils/translation'
import {
  Divider,
  TableNotification,
  TableNotificationBar,
} from '../../../components/tables/styled'
import ProjectSelector from '../../../components/selector/ProjectSelector'
import { getCurrencyAndRegion, isAIWAddon } from '../../../utils/payment'
import { allAddonsTypes } from '../../../utils/addonTypes'
import {
  getMaxValuesForUser,
  isLifetimePlanUser,
  isFreeTrialUser,
} from '../../../utils/freeVersionBlock'
import {
  kissmetricsRecordingEvent,
  KISSMETRICS_TRACK_EVENTS,
  PROPERTY_NAMES,
  PROPERTY_VALUES,
} from '../../../utils/kissmetrics'
import { migrateOldLifetime } from '../../../utils/api'
import { DEFAULT_AIW_WORDS_LIMITS } from '../../../utils/consts.mjs'
import { formatNumber } from '../../../utils/numbers'
import { Mixpanel, MIXPANEL_PROPS } from '../../../utils/mixpanel'
import ConfirmationModal from '../../../components/modal/ConfirmationModal'
import { sendMessage } from '../../../utils/functions'

import { Row, AddonCard, AddonIcon } from './styled'
import SuccessModal from './SuccessModal'

const desktopStyle = {
  width: '90%',
  maxWidth: '784px',
  height: 'fit-content',
  maxHeight: '90vh',
  overflow: 'unset',
  overflowY: 'auto',
}
const mobileStyle = {
  width: '100%',
}
const ModalHeaderContent = styled.div({
  display: 'flex',
  alignItems: 'center',
})

class PurchaseAddonModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      selectedProject: null,
      selectedAddon:
        props.addonDetail?.addons?.[props.addonDetail?.selectedAddonIndex],
      isOpenConfirmation: false,
      isOpenSuccessModal: false,
      addonTitleSuccessModal: '',
      successAddon: null,
    }
  }

  componentDidUpdate(prevProps) {
    const { isOpen, addonDetail, currentProject, projects } = this.props
    const { selectedProject } = this.state
    if (prevProps.isOpen !== isOpen) {
      this.setState({
        isLoading: false,
        selectedAddon: addonDetail?.addons
          ? addonDetail?.addons[addonDetail?.selectedAddonIndex]
          : null,
      })
    }

    if (currentProject && prevProps.currentProject?.id !== currentProject.id) {
      this.setState({
        selectedProject: currentProject,
      })
    }

    if (!selectedProject) {
      const firstProject = projects ? projects[0] : null
      this.setState({
        selectedProject: currentProject || firstProject,
      })
    }
  }

  onChangeProject = (selectedProject) => {
    this.setState({ selectedProject })
  }

  onChangeSelectedOption = (index) => {
    this.setState({ selectedAddon: this.props.addonDetail.addons[index] })
  }

  purchaseAddon = () => {
    const { isLoading, selectedAddon } = this.state
    const { user } = this.props
    const oldLifetimePlan =
      isLifetimePlanUser() && user.subscription.planMustMigrate

    const selectedProject =
      this.props.selectedProject ||
      this.state.selectedProject ||
      (this.props.projects && this.props.projects[0]) ||
      null

    if (!isLoading) {
      this.setState({ isLoading: true })
      kissmetricsRecordingEvent(KISSMETRICS_TRACK_EVENTS.addon_clicked, {
        [PROPERTY_NAMES.btn_name]:
          PROPERTY_VALUES.addon_clicked[selectedAddon?.addonType],
      })
      if (oldLifetimePlan) {
        migrateOldLifetime()
          .then((res) => {
            if (res.status === 204) {
              setTimeout(() => {
                this.props.onPurchaseAddon({
                  addon: selectedAddon,
                  project:
                    selectedAddon?.addonType ===
                      allAddonsTypes.ADDON_COMPETITOR ||
                    selectedAddon?.addonType ===
                      allAddonsTypes.ADDON_TRACKEDKEYWORDS
                      ? this.state.selectedProject || selectedProject
                      : null,
                  successCallback: () =>
                    this.setState({
                      isOpenSuccessModal: true,
                      addonTitleSuccessModal: selectedAddon.title,
                      successAddon: selectedAddon,
                    }),
                })
              }, 5000)
            } else {
              throw new Error('migrating failed')
            }
          })
          .catch((error) => {
            console.error('error', error)
            this.setState({ isLoading: false })
          })
      } else {
        this.props.onPurchaseAddon({
          addon: selectedAddon,
          project:
            selectedAddon?.addonType === allAddonsTypes.ADDON_COMPETITOR ||
            selectedAddon?.addonType === allAddonsTypes.ADDON_TRACKEDKEYWORDS
              ? this.state.selectedProject || selectedProject
              : null,
          successCallback: () =>
            this.setState({
              isOpenSuccessModal: true,
              addonTitleSuccessModal: selectedAddon.title,
              successAddon: selectedAddon,
            }),
        })
      }
    }
  }

  render() {
    const {
      isLoading,
      selectedAddon,
      isOpenConfirmation,
      isOpenSuccessModal,
      selectedProject: stateSelectedProject,
      addonTitleSuccessModal,
      successAddon,
    } = this.state
    const {
      addonDetail,
      user,
      selectedProject: propsSelectedProject,
      projects,
      isOpen,
      onClose,
      shouldTriggerAddProjectFlow,
    } = this.props
    const { region } = getCurrencyAndRegion(user.countryCode)
    const { AIW_WORDS_LIMITS } = getMaxValuesForUser()

    const oldLifetimePlan =
      isLifetimePlanUser() && user.subscription.planMustMigrate

    if (!addonDetail && !isOpenSuccessModal) return null

    const isAIWAddons = isAIWAddon(addonDetail?.addonType)

    const selectedProject =
      propsSelectedProject ||
      stateSelectedProject ||
      (projects && projects[0]) ||
      null

    const { used: keywordAddonsCount, limit: keywordAddonsLimit } =
      selectedProject?.limits?.add_ons?.['2022_addon_trackedkeywords'] || {}

    const isBuyButtonDisabled =
      selectedAddon?.addonType === allAddonsTypes.ADDON_TRACKEDKEYWORDS &&
      keywordAddonsCount > 0 &&
      keywordAddonsCount === keywordAddonsLimit

    return (
      <>
        {isOpen && (
          <Modal
            isOpen={isOpen}
            overlayStyle={{ zIndex: 10001 }}
            desktopStyle={desktopStyle}
            mobileStyle={mobileStyle}
            parentSelector={() =>
              document.getElementById('prompt-modal-upgrade')
            }
            onAfterOpen={() => {
              if (isOpen) {
                if (!isAIWAddon(addonDetail?.addonType)) {
                  Mixpanel.trackAddonConfirmationView({
                    user,
                    addonType: addonDetail?.addonType,
                  })
                }

                if (isAIWAddon(addonDetail?.addonType)) {
                  Mixpanel.trackAiwAccountBillingView(user?.subscription?.tier)
                }
              }
            }}
          >
            <ModalHeader doubleBorder>
              <ModalHeaderContent>
                <CloseButton
                  data-testid="purchase-addon-modal-close"
                  onClick={onClose}
                  styles={{ top: '20px' }}
                />
                <Text
                  fontFamily={fonts.primaryBook}
                  fontSize="24px"
                  lineHeight="24px"
                  color={palette.darkGray}
                  textAlign="center"
                  style={{ width: '100%' }}
                >
                  {translate('buy_addon_modal_heading')}
                </Text>
              </ModalHeaderContent>
            </ModalHeader>
            <ModalContent
              styles={{ position: 'relative', padding: '33px 40px 21px 40px' }}
            >
              {selectedAddon?.addonType ===
                allAddonsTypes.ADDON_TRACKEDKEYWORDS &&
                keywordAddonsCount > 0 && (
                  <TableNotificationBar style={{ marginBottom: '40px' }}>
                    <TableNotification
                      type="warning"
                      hideClose
                      content={
                        <Text lineHeight="24px" boldColor={palette.darkGray}>
                          {translate(
                            'tracked_kw_addon_limit',
                            keywordAddonsCount,
                            keywordAddonsLimit - keywordAddonsCount,
                          )}
                        </Text>
                      }
                      style={{ marginTop: '0px' }}
                    />
                  </TableNotificationBar>
                )}
              {selectedAddon?.addonType === allAddonsTypes.ADDON_DOMAIN && (
                <Text
                  fontFamily={fonts.primary}
                  fontSize="16px"
                  lineHeight="22px"
                  color={palette.pureBlack}
                  textAlign="center"
                  margin="5px 0 25px"
                >
                  {translate('bonus_message_projects')}
                </Text>
              )}
              {isAIWAddons && (
                <Text
                  fontFamily={fonts.primary}
                  fontSize="16px"
                  lineHeight="22px"
                  color={palette.pureBlack}
                  textAlign="center"
                  margin="5px 0 10px"
                >
                  {translate('aiw_addon_modal_subheading')}
                </Text>
              )}
              {isAIWAddons && AIW_WORDS_LIMITS > DEFAULT_AIW_WORDS_LIMITS && (
                <Text
                  fontSize="16px"
                  lineHeight="22px"
                  color={palette.pureBlack}
                  boldColor={palette.pureBlack}
                  textAlign="center"
                  margin="5px 0 25px"
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      'aiw_addon_modal_subheading2',
                      formatNumber(AIW_WORDS_LIMITS, false, 0, region, false),
                    ),
                  }}
                />
              )}
              <Text
                fontFamily={fonts.primaryMedium}
                fontSize="14px"
                lineHeight="16px"
                color={palette.pureBlack}
                textAlign="left"
                margin="5px 0"
              >
                {translate('addon_label')}
              </Text>
              {addonDetail?.addons &&
                addonDetail.addons.map((option, index) => (
                  <Row
                    key={`option_${index}`}
                    style={{
                      width: '100%',
                    }}
                  >
                    <AddonCard
                      clickable={isAIWAddons}
                      selected={
                        isAIWAddons &&
                        option.addonType === selectedAddon?.addonType
                      }
                      onClick={() => {
                        if (isAIWAddons) this.onChangeSelectedOption(index)
                      }}
                    >
                      <Row
                        style={{
                          margin: 0,
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <AddonIcon
                          icon={option.icon}
                          background={option.bgColor}
                          style={{ marginRight: '15px' }}
                        />
                        <Text
                          fontFamily={fonts.primaryBook}
                          fontSize="14px"
                          lineHeight="22px"
                          color={palette.darkGray}
                        >
                          {option.title}
                        </Text>
                      </Row>
                      <Row
                        style={{
                          margin: 0,
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          padding: '0 0 0 15px',
                        }}
                      >
                        <Text
                          fontFamily={fonts.primaryBook}
                          fontSize="14px"
                          lineHeight="22px"
                          color={palette.blue}
                        >
                          {option.addonPrice}
                        </Text>
                      </Row>
                    </AddonCard>
                  </Row>
                ))}
              {(selectedAddon?.addonType === allAddonsTypes.ADDON_COMPETITOR ||
                selectedAddon?.addonType ===
                  allAddonsTypes.ADDON_TRACKEDKEYWORDS) && (
                <>
                  <Text
                    fontFamily={fonts.primaryMedium}
                    fontSize="14px"
                    lineHeight="16px"
                    color={palette.pureBlack}
                    textAlign="left"
                    margin="5px 0"
                  >
                    {translate('label_ai_writer_project_selector')}
                  </Text>
                  <ProjectSelector
                    projects={
                      propsSelectedProject ? [selectedProject] : projects
                    }
                    selectedProject={selectedProject}
                    onChangeProject={this.onChangeProject}
                    hideAddButton
                    fullWidth
                    smallBox
                    style={{
                      margin: '0',
                      width: '100%',
                    }}
                  />
                </>
              )}
              <Divider
                key="divider"
                style={{
                  margin: '40px 0',
                  backgroundColor: palette.lightGray50,
                }}
              />
              <Text
                fontFamily={fonts.primaryBook}
                fontSize="16px"
                lineHeight="22px"
                color={palette.pureBlack}
                textAlign="center"
              >
                {translate('billing_changes_summary')}
              </Text>
              <Text
                fontFamily={fonts.primary}
                fontSize="16px"
                lineHeight="22px"
                color={palette.darkGray50}
                textAlign="center"
                margin="5px 0"
              >
                {selectedAddon?.billingChangeSummary}
              </Text>
              {oldLifetimePlan && (
                <Text
                  fontFamily={fonts.primaryLight}
                  fontSize="15px"
                  lineHeight="20px"
                  color={palette.darkGray50}
                  textAlign="center"
                  margin="10px 0 30px"
                >
                  {translate('change_plan_lifetime_addon_confirm')}
                </Text>
              )}
            </ModalContent>
            <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
              <OutlineButton
                static
                color={palette.darkGray50}
                onClick={onClose}
              >
                {translate('cancel')}
              </OutlineButton>
              <OutlineButton
                static
                color={palette.white}
                onClick={() => {
                  if (isFreeTrialUser()) {
                    this.setState({ isOpenConfirmation: true })
                  } else {
                    this.purchaseAddon()
                  }
                }}
                style={
                  isLoading
                    ? { padding: 5 }
                    : {
                        backgroundColor: isBuyButtonDisabled
                          ? palette.white
                          : palette.blue,
                      }
                }
                disabled={isBuyButtonDisabled}
              >
                {isLoading ? (
                  <LoadingResponsive
                    size="30px"
                    height="42px"
                    offsetY="5%"
                    color={palette.blue}
                  />
                ) : (
                  translate('buy_addon_button')
                )}
              </OutlineButton>
            </ModalFooter>

            <ConfirmationModal
              isOpen={isOpenConfirmation}
              title={translate('confirm_addon_trial_heading')}
              message={translate('confirm_addon_trial_subheading')}
              overlayStyle={{ zIndex: 10002 }}
              buttonType={1}
              onAccept={() => {
                this.setState({ isOpenConfirmation: false })
                this.purchaseAddon()
              }}
              onDeny={() => this.setState({ isOpenConfirmation: false })}
            />
          </Modal>
        )}
        <SuccessModal
          isOpen={isOpenSuccessModal}
          addonTitle={addonTitleSuccessModal}
          onClose={() => {
            this.setState({
              isOpenSuccessModal: false,
            })
            if (
              successAddon?.addonType === allAddonsTypes.ADDON_DOMAIN &&
              shouldTriggerAddProjectFlow
            ) {
              sendMessage('ADD_PROJECT', {
                eventProperty: {
                  addProjectButtonLocation:
                    MIXPANEL_PROPS.ADD_PROJECT_BUTTON_LOCATION.values
                      .PROJECT_ADDON,
                },
              })
            }
          }}
        />
      </>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  currentProject: selectCurrentProject(),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseAddonModal)
